module.exports = "/static/img/merchant-logo.d4ee176a76bba42b051c8d1bb8b107cc.png";